var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Arrow_Left",
    "data-name": "Icon / Arrow Left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-871.868,20.575h0a.748.748,0,0,0,0-1.057l-5.157-5.164h14.378a.75.75,0,0,0,.75-.75h0a.75.75,0,0,0-.75-.75h-14.378l5.157-5.164a.748.748,0,0,0,0-1.057h0a.748.748,0,0,0-1.057,0l-6.441,6.441a.751.751,0,0,0,0,1.061l6.441,6.441A.748.748,0,0,0-871.868,20.575Z",
    transform: "translate(882.896 -1.603)",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.a5fb8046eff3405b1220b8c3d805d8e2.svg";
export { ForwardRef as ReactComponent };